//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    BRANDS_EDIT_BRAND_GET_BRAND_REQUEST,
    BRANDS_EDIT_BRAND_REQUEST,
    BRANDS_EDIT_BRAND_OPEN_MODAL,
    BRANDS_EDIT_NEW_BRAND_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {

    brandsGetBrandResult,
    brandsEditBrandResult,
    brandsEditNewBrandResult,
} from 'Redux/actions';



function* getBrand({ payload }) {
    try {
        let data = null
        if (payload) {
            let QUERY = `
            query getBrand ($id: Int!) {
                result: getBrand (id: $id) {
                    id
                    code
                    title
                    domains
                    homePageUrl
                    tosUrl
                    helpUrl
                    address
                    phone
                    loginBackgroundImage
                    loginBackgroundColor
                    loginCompanyLogo
                    favicon
                    inAppLogo

                    createdBy
                    createdOn
                    updatedBy
                    updatedOn
                }
            }
        `;

            data = yield call(
                clientQuery,
                QUERY,
                {
                    id: payload
                },
                endpoints.GRAPHQL_GENERAL,
            );
        }
        let result = null
        if (data?.result) {
            result = { ...data.result };
            if (result?.domains?.length > 0) {
                result.domains = JSON.parse(JSON.parse(result.domains));
            }
        }

        yield put(brandsGetBrandResult(result))

    } catch (exc) {
        ExceptionManager(exc, 'Modules/brands/views/components/editBrand/redux/saga', 'getRole');
    }
}

function* editBrand({ payload }) {
    try {
        let QUERY = `
            mutation updateBrand ($id: Int!, $code: String!, $title: String!, $domains: AWSJSON, $homePageUrl: String, $tosUrl: String, $helpUrl: String, $address: String, $phone: String, $loginBackgroundImage: String, $loginBackgroundColor: String, $loginCompanyLogo: String, $inAppLogo: String, $favicon: String) {
                result: updateBrand (id: $id, code: $code, title: $title, domains: $domains, homePageUrl: $homePageUrl, tosUrl: $tosUrl, helpUrl: $helpUrl, address: $address, phone: $phone, loginBackgroundImage: $loginBackgroundImage, loginBackgroundColor: $loginBackgroundColor, loginCompanyLogo: $loginCompanyLogo, inAppLogo: $inAppLogo, favicon: $favicon) {
                    id
                    code
                    title
                    domains
                    homePageUrl
                    tosUrl
                    helpUrl
                    address
                    phone
                    loginBackgroundImage
                    loginBackgroundColor
                    loginCompanyLogo
                    favicon
                    inAppLogo

                    createdBy
                    createdOn
                    updatedBy
                    updatedOn
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        let result = null
        if (data?.result) {
            result = { ...data.result };
            if (result?.domains?.length > 0) {
                result.domains = JSON.parse(JSON.parse(result.domains));
                if (!Array.isArray(result.domains)) {
                    result.domains = JSON.parse(result.domains);
                }
            }
        }
        yield put(brandsEditBrandResult(result))

    } catch (exc) {
        yield put(brandsEditBrandResult({ error: exc }))
        ExceptionManager(exc, 'Modules/brands/views/components/editBrand/redux/saga', 'editBrand', true);
    }
}

function* newBrand({ payload }) {
    try {
        let QUERY = `
            mutation createBrand ($code: String!, $title: String!, $domains: AWSJSON, $homePageUrl: String, $tosUrl: String, $helpUrl: String, $address: String, $phone: String, $loginBackgroundImage: String, $loginBackgroundColor: String, $loginCompanyLogo: String, $favicon: String, $inAppLogo: String) {
                result: createBrand (code: $code, title: $title, domains: $domains, homePageUrl: $homePageUrl, tosUrl: $tosUrl, helpUrl: $helpUrl, address: $address, phone: $phone, loginBackgroundImage: $loginBackgroundImage, loginBackgroundColor: $loginBackgroundColor, loginCompanyLogo: $loginCompanyLogo, favicon: $favicon, inAppLogo: $inAppLogo) {
                    id
                    code
                    title
                    domains
                    homePageUrl
                    tosUrl
                    helpUrl
                    address
                    phone
                    loginBackgroundImage
                    loginBackgroundColor
                    loginCompanyLogo
                    favicon
                    inAppLogo

                    createdBy
                    createdOn
                    updatedBy
                    updatedOn
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        let result = null
        if (data?.result) {
            result = { ...data.result };
            if (result?.domains?.length > 0) {
                result.domains = JSON.parse(JSON.parse(result.domains));
                if (!Array.isArray(result.domains)) {
                    result.domains = JSON.parse(result.domains);
                }
            }
        }
        yield put(brandsEditNewBrandResult(result))

    } catch (exc) {
        yield put(brandsEditNewBrandResult({ error: true }))
        ExceptionManager(exc, 'Modules/brands/views/components/editBrand/redux/saga', 'newBrand', true);
    }
}

function* watchCatalogRequests() {
    yield takeEvery(BRANDS_EDIT_BRAND_OPEN_MODAL, getBrand);
    yield takeEvery(BRANDS_EDIT_BRAND_GET_BRAND_REQUEST, getBrand);
    yield takeEvery(BRANDS_EDIT_BRAND_REQUEST, editBrand);
    yield takeEvery(BRANDS_EDIT_NEW_BRAND_REQUEST, newBrand);
}
//credencialValidation


//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchCatalogRequests)
    ]);
}